<template><div><h1>发送 ajax 请求</h1>
<div class="tip">
<p><code>AjaxPlugin</code> 插件依赖于 <a href="https://github.com/mzabriskie/axios">axios</a><br>
详细 API 文档请查看：<a href="https://github.com/mzabriskie/axios">axios</a></p>
</div>
<h2>版本要求</h2>
<p><code>AjaxPlugin</code>在<code>vux@^2.1.0-rc.20</code>开始支持</p>
<h2>引入</h2>
<p><code>main.js</code> 入口文件中引入：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { AjaxPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(AjaxPlugin)
</code></pre>
<h2>兼容性问题</h2>
<p>需要注意的是<code>axios</code>是基于<code>Promise</code>的，因此如果你需要兼容低版本浏览器(<a href="http://caniuse.com/#feat=promises">caniuse</a>)，需要引入<code>polyfill</code>。</p>
<p><code>Polyfill</code> 推荐使用 <a href="https://github.com/stefanpenner/es6-promise">es6-promise</a></p>
<pre class="hljs"><code><span class="hljs-built_in">require</span>(<span class="hljs-string">'es6-promise'</span>).polyfill()
</code></pre>
<h2>全局使用</h2>
<pre class="hljs"><code>Vue.http.post(<span class="hljs-string">'/api'</span>).then()
</code></pre>
<h2>组件中使用</h2>
<pre class="hljs"><code><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  created () {
    <span class="hljs-keyword">this</span>.$http.post(<span class="hljs-string">'/api'</span>).then(<span class="hljs-function">(<span class="hljs-params">{data}</span>) =&gt;</span> {
      <span class="hljs-built_in">console</span>.log(data)
    })
  }
}
</code></pre>
</div></template><script>
export default {
  head: {"title":"Vue 中使用 ajax | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-ajax-163.vue?adc710e0